module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "计算公式"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "numerical text-l"
  }, [_c('span', [_vm._v("数值A")]), _vm._v(" "), _c('p', {
    staticClass: "public-gray"
  }, [_vm._v("= 截止该商品最后夺酒最后50个参与时间数值之和")]), _vm._v(" "), _c('p', [_vm._v("= "), _c('span', {
    staticClass: "public-red"
  }, [_vm._v(_vm._s(_vm.item.sum))]), _vm._v(" "), _c('span', {
    staticClass: "fr detail",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v(_vm._s(_vm.show ? '计算详情 收起' : '计算详情 查看'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "list"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.item.robLogList), function(item2) {
    return _c('div', {
      staticClass: "flex public-gray"
    }, [_c('span', {
      staticClass: "timer "
    }, [_vm._v(_vm._s(_vm._f("timerForm")(item2.created_time)))]), _vm._v(" "), _c('span', {
      staticClass: "flex-1 public-red"
    }, [_vm._v(_vm._s(_vm._f("code")(item2.show_time)))]), _vm._v(" "), _c('span', {
      staticClass: "flex-1 ellipsis"
    }, [_vm._v(_vm._s(item2.user_info.name))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "numerical text-l"
  }, [_c('span', [_vm._v("计算结果")]), _vm._v(" "), _c('p', [_vm._v("幸运号码："), _c('span', {
    staticClass: "public-red"
  }, [_vm._v(_vm._s(_vm.item.final_number))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formula-top text-l"
  }, [_c('span', [_vm._v("计算公式")]), _vm._v(" "), _c('p', [_vm._v("（数值÷商品参与人次）取余数+10000001")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: " timer"
  }, [_vm._v("时间")]), _vm._v(" "), _c('span', {
    staticClass: "flex-1 public-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "flex-1"
  }, [_vm._v("用户")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a80fa17"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/takeWine/formula.vue
// module id = 540
// module chunks = 0